import React, { ChangeEvent } from "react";

interface FileUploadProps {
	fileUploads: FileUploadState[];
	setFileUploads: React.Dispatch<React.SetStateAction<FileUploadState[]>>;
}

export interface FileUploadState {
	file: File | null;
	name: string;
	description: string;
	ext: string;
}

const FileUpload: React.FC<FileUploadProps> = ({
	fileUploads,
	setFileUploads,
}) => {
	const handleFileChange = (
		index: number,
		event: ChangeEvent<HTMLInputElement>
	) => {
		const updatedFileUploads = [...fileUploads];
		if (event.target.files && event.target.files.length > 0) {
			updatedFileUploads[index].file = event.target.files[0];
		}
		setFileUploads(updatedFileUploads);
	};

	const handleNameChange = (
		index: number,
		event: ChangeEvent<HTMLInputElement>
	) => {
		const updatedFileUploads = [...fileUploads];
		updatedFileUploads[index].name = event.target.value;
		setFileUploads(updatedFileUploads);
	};

	const handleDescriptionChange = (
		index: number,
		event: ChangeEvent<HTMLTextAreaElement>
	) => {
		const updatedFileUploads = [...fileUploads];
		updatedFileUploads[index].description = event.target.value;
		setFileUploads(updatedFileUploads);
	};

	const handleExtChange = (
		index: number,
		event: ChangeEvent<HTMLInputElement>
	) => {
		const updatedFileUploads = [...fileUploads];
		if (event.target.files && event.target.files.length > 0) {
			const file = event.target.files[0];
			const fileExtension = file.type; // Get the file extension
			updatedFileUploads[index].ext = fileExtension;
			setFileUploads(updatedFileUploads);
			console.log(updatedFileUploads[index].ext);
		}
	};

	const addFileUpload = () => {
		setFileUploads([
			...fileUploads,
			{ file: null, name: "", description: "", ext: "" },
		]);
	};

	const removeForm = (index: number) => {
		const newForms = fileUploads.filter((_, i) => i !== index);
		setFileUploads(newForms);
	};

	return (
		<div className="flex flex-col mt-5 space-y-5">
			{fileUploads.map((upload, index) => (
				<div
				key={index}
				className="flex flex-col sm:flex-row items-center sm:items-start gap-4 bg-gray-100 p-4 rounded-lg shadow-md"
				>
				<input
					type="file"
					onChange={(e) => {
					handleFileChange(index, e);
					handleExtChange(index, e);
					}}
					className="file-input border border-gray-300 rounded-md p-2 w-full sm:w-auto"
					required
				/>
				<div className="flex flex-col w-full sm:w-auto">
					<input
					type="text"
					placeholder="File Name"
					value={upload.name}
					onChange={(e) => handleNameChange(index, e)}
					className="border border-gray-300 rounded-md p-2 w-full"
					required
					/>
					<textarea
					placeholder="File Description"
					value={upload.description}
					onChange={(e) => handleDescriptionChange(index, e)}
					className="border border-gray-300 rounded-md p-2 w-full mt-2"
					required
					/>
				</div>
				<button
					type="button"
					onClick={() => removeForm(index)}
					className="text-white bg-red-500 hover:bg-red-600 rounded-full p-2 transition duration-200"
				>
					✖
				</button>
				</div>
			))}

			<button
				type="button"
				onClick={addFileUpload}
				className="bg-blue-600 hover:bg-blue-700 text-white rounded-md px-4 py-2 transition duration-200 self-center"
			>
				+ Add More Files
			</button>
		</div>

	);
};

export default FileUpload;
